import { render, staticRenderFns } from "./WikiHome.vue?vue&type=template&id=34763bee"
import script from "./WikiHome.vue?vue&type=script&lang=js"
export * from "./WikiHome.vue?vue&type=script&lang=js"
import style0 from "./WikiHome.vue?vue&type=style&index=0&id=34763bee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports